module.exports = __webpack_public_path__ + "static/media/tick-black.516aaf61.svg";